import getTimeZone from '../services/getTimeZone';
import setSupportedTimeZones from '../data/mutators/setSupportedTimeZones';

export default async function loadTimeZoneOptions() {
    await getTimeZone().then(timeZones => {
        setSupportedTimeZones(timeZones);
    });
}
